import { Permission } from 'interfaces/permissionOption';
import { usePermissions } from 'utils/usePermissions';

export const useCasesAndSlidesEditingPermissions = () => {
  const { hasPermission, hasSomePermissions } = usePermissions();

  const hasMetadataEditingPermissions = hasSomePermissions([
    Permission.AddAndEditMetadataToAnyStudies,
    Permission.AddAndEditMetadataToOwnStudies,
  ]);
  const hasClinicalDataEditingPermissions = hasSomePermissions([
    Permission.AddAndEditClinicalDataToAnyStudies,
    Permission.AddAndEditClinicalDataToOwnStudies,
  ]);
  const hasCaseLabelEditingPermissions = hasMetadataEditingPermissions || hasPermission(Permission.ApplyCaseManifest);
  const hasSomeEditingPermissions = hasClinicalDataEditingPermissions || hasCaseLabelEditingPermissions;

  return {
    hasPermission,
    hasSomeEditingPermissions,
    hasMetadataEditingPermissions,
    hasClinicalDataEditingPermissions,
    hasCaseLabelEditingPermissions,
  } as const;
};
